/**************************************************
 * Nombre:       Potenciales
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {useEffect, useState} from 'react';
import {Button, Grid, Typography, useMediaQuery} from "@mui/material";
import {ArchiveBook, DocumentCloud} from "iconsax-react";
import {Ho_ManejoTargetas} from "../../Modulo_Tarjetas/Hocs/Ho_ManejoTargetas";
import Tarjeta_Boletines from "../Tarjetas/Tarjeta_Boletines";
import {useDialogo} from "../../Modulo_Dialgos/Hooks/useDialog";
import Dialogo_Boletines from "../Dialogos/Dialogo_Boletines";
import useRecuperarColleccionListeningProg from "../../Servicios/BD/useRecuperarColleccionListeningProg";
import {ACENTO} from "../../Constantes";
import Tarjeta_Potenciales from "../Tarjetas/Tarjeta_Potenciales";
import Dialogo_Potencial from "../Dialogos/Dialogo_Potencial";
import {collection, query, where} from "firebase/firestore";
import {exportarJsonToExcel} from "../../Modulo_Excel/Exportar/ExportarJsonToExcel";
import {fire} from "../../fire";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";
import {LoadingButton} from "@mui/lab";
import {theme} from "../../Tema";


const Potenciales = ({estado = 'nuevo'}) => {
    const masSM = useMediaQuery(theme.breakpoints.up('md'))
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Potencial})
    const [wheres, setWheres] = useState([where('estado', '==', 'none')])
    const {data, cargarMas} = useRecuperarColleccionListeningProg({col: 'potenciales', wheres: wheres})
    const [cargando, setCargando] = useState(false)


    const exportar = () => {
        setCargando(true)
        let q = query(collection(fire, 'potenciales'), where('estado', '==', estado))
        obtenerColeccionQuery(q).then((dox) => {
            if (dox.res) {
                exportarJsonToExcel({data: dox.data, nombre: 'Potenciales ' + estado})
            } else {
                alert('Ups, algo inesperado paso, por favor intentalo mas tarde')
            }
            setCargando(false)
        })


    }

    useEffect(() => {
        if (estado) {
            setWheres([where('estado', '==', estado)])
        }
    }, [estado])
    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            sx={{py: 4, px: 4}}
        >

            <Dialogo/>

            <Grid item lg={6} sm={6} xs={6}>
                <Typography sx={{fontSize: masSM ? 28 : 22, fontWeight: 800}}>{estado.toUpperCase()}</Typography>
            </Grid>


            <Grid item container lg={6} sm={6} xs={6} sx={{justifyContent: "flex-end"}}>
                <LoadingButton
                    onClick={() => exportar()}
                    loading={cargando} variant={'outlined'} sx={{color: "#FC783E"}}
                    startIcon={<DocumentCloud variant={'Bold'}/>}>Descargar
                    Datos</LoadingButton>
            </Grid>

            <Grid item lg={12} sm={12} xs={12} sx={{marginTop: 4}}>
                <Ho_ManejoTargetas Card={Tarjeta_Potenciales} data={data} click={abrir}/>
            </Grid>

            <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: "center", mt: 2, mb: 2}}>
                <Button
                    onClick={() => cargarMas()}
                    variant={'outlined'} sx={{color: '#FC783E'}}>Cargar Mas</Button>
            </Grid>

        </Grid>
    )
}

export default Potenciales;